import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetTitleAudioCachedV1Response } from './get-title-audio-cached-v1-response';
import { getTitleAudioCachedV1ResponseSchema } from './get-title-audio-cached-v1-response';

export async function getTitleAudioCachedV1Api(
  slug: string,
): Promise<IValidatedResponse<IGetTitleAudioCachedV1Response>> {
  return getRequest<IGetTitleAudioCachedV1Response>({
    path: `/challenges/${slug}/audio/title/cached/v1`,
    schema: getTitleAudioCachedV1ResponseSchema,
  });
}
